module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../node_modules/babel-loader/lib/index.js??ref--1-oneOf-1!../../../node_modules/eslint-loader/index.js??ref--0-0!./WxSdk.js"));
	});
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy!./src/pages/Test/WxSdk.js
// module id = 982
// module chunks = 97